<template>
  <one-column-layout>

        <title-bar title="Edit Patient" class="border-bottom" slot="titleBar">
          <div class="smd-spacer text-center align-self-flex-end">
            <label>Personal Information</label>
          </div>
          <smd-btn icon="smd-icon-split-screen" @click="gotoPage($options.Routes.ROUTE_PATIENT_PROFILE_PREVIEW)"/>
          <smd-btn icon="smd-icon-action-close" @click="close"/>
        </title-bar>

        <two-column-layout class="m-sidebar"
                           :sidebar-styles="['right-shadow']">
          <one-column-layout slot="sidebar" :content-styles="['full-width']">
            <title-bar title="Add/Edit Information" type="sub" slot="titleBar"
                       class="justify-content-center space-l"/>

            <div class="smd-nav--editor">
              <div class="smd-nav__item" @click="gotoPage($options.Routes.ROUTE_PATIENT_INFO)">
                <i class="smd-icon-menu-profile"/>
                <p>Personal Information</p>
                <i class="smd-icon-arrow-right"/>
              </div>

              <div class="smd-nav__item" @click="gotoPage($options.Routes.ROUTE_MEDICAL_HISTORY)">
                <i class="smd-icon-med-history"/>
                <p> Medical History</p>
                <i class="smd-icon-arrow-right"/>
              </div>

              <div class="smd-nav__item" @click="gotoPage($options.Routes.ROUTE_OBSTETRIC_HISTORY)">
                <i class="smd-icon-obstetric-history"/>
                <p>Obstetric History</p>
                <i class="smd-icon-arrow-right"/>
              </div>
            </div>

          </one-column-layout>

          <one-column-layout class="space-l" slot="content">
            <title-bar title="Patient Profile" type="page" slot="titleBar"/>
            <template>
              <div class="pogs-panel--o">
                <header>
                  <i class="smd-icon-menu-profile"></i>
                  <h3>Personal Information</h3>
                  <div class="smd-spacer"/>
                </header>
                <div class="content">
                  <div class="patient-header">
                    <div class="smd-profile-image l"
                         :style="patient.avatar ? 'background:url('+ patient.avatar + ');' : undefined">
                      <template v-if="!patient.avatar">
                        {{initials}}
                      </template>
                    </div>
                    <div class="patient-data">
                      <div class="patient-data__details">
                        <label dark>0140</label>
                        <div class="patient-data__name">
                          <h1>{{ patient.firstName }} {{patient.middleName}} {{ patient.lastName }}</h1>
                        </div>
                        <div class="patient-data__meta">
                          <p><label>DOB:</label> {{ patient.birthDate }}</p>
                          <p><label>Age:</label> {{ patient.birthDate | computeAge }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="pogs-panel--o">
                <header>
                  <i class="smd-icon-med-history"></i>
                  <h3>Medical History</h3>
                  <div class="smd-spacer"/>
                </header>
                <div class="content">
                  <div class="pogs-list--tags">
                  <!--  <div class="pogs-list__item" v-for="history in filteredMedicalHistory">{{ history.conditionId | getValueByKey($options.healthConditions)}}</div>-->
                    <div class="pogs-list--tags">
                      <div class="pogs-list__item" v-for="history in medicalHistory" :key="history.conditionId">
                        {{ history.conditionId | decodeMedicalHistoryCondition }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="pogs-panel--o">
                <header>
                  <i class="smd-icon-obstetric-history"></i>
                  <h3>Obstetric History</h3>
                  <div class="smd-spacer"/>
                </header>
              </div>

            </template>
          </one-column-layout>

        </two-column-layout>

  </one-column-layout>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {GETTER_PATIENTS, GETTER_SELECTED_PATIENT} from '../../../store/modules/patients'
    import HealthConditions from '../../../reference/medical/health-conditions'
    import Routes from '../../../router/route-constants'

    export default {
        name: "pogs-patient-profile",
        data(){
          return{
            selectedPatientId: this.$route.params.patientid,
          }
        },
        computed: {
          ...mapGetters({
            patients: GETTER_PATIENTS,
            selectedPatient: GETTER_SELECTED_PATIENT
          }),
          medicalHistory() {
            return this.selectedPatient.medicalHistory || {};
          },
          patient(){
            return this.selectedPatientId === null ?
              this.$options.initPatient :
              this.patients.find(patient => patient.patientId === this.selectedPatientId);
          },
          initials(){
            return this.patient.firstName && this.patient.lastName ? this.patient.firstName.substring(0,1) + this.patient.lastName.substring(0,1) : ' ';
          }
        },
        methods: {
          gotoPage(route){
            this.$router.push({
              name: route,
              params: {
                patientid: this.selectedPatientId
              }
            });
          },
          close(){
            this.$router.push({name: Routes.ROOT_ROUTE_PATIENTS});
          }
        },
        HealthConditions,
        Routes
    }
</script>

